import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.storm.image.delete;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORM_IMAGE_DELETE',
	method: 'POST',
	url: '/storm/image/delete.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
